/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMicrosoftTeams = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M12.717 2a3.1 3.1 0 0 0-3.099 2.857h1.426a2.387 2.387 0 0 1 2.39 2.381v.867a3.093 3.093 0 0 0 2.392-3.01A3.102 3.102 0 0 0 12.717 2zm7.174 1.905c-.57 0-1.118.226-1.521.627a2.14 2.14 0 0 0 1.52 3.658c.571 0 1.119-.225 1.522-.627a2.138 2.138 0 0 0 0-3.03 2.157 2.157 0 0 0-1.522-.628zM2.435 5.81C1.644 5.81 1 6.45 1 7.238v8.572c0 .787.644 1.428 1.435 1.428h8.608c.792 0 1.435-.64 1.435-1.429V7.24c0-.789-.643-1.43-1.434-1.43zm1.913 2.857H9.13v.952H7.217v4.762h-.956V9.619H4.348zm9.087.952v6.19a2.387 2.387 0 0 1-2.391 2.382H8.269A4.778 4.778 0 0 0 12.956 22c2.64-.001 4.783-2.134 4.783-4.763V9.62zm5.26 0v7.62c0 .39-.038.77-.11 1.137A3.102 3.102 0 0 0 23 15.572V9.62z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgMicrosoftTeams as MicrosoftTeams };
